<template>
    <div>
        <div class="releasenotes">
        <h3 class="purple-text">Terms of Service  </h3>
        <p>Terms of Service for 27pub.com

Effective Date: November 19, 2025

Welcome to 27pub.com. By accessing or using this website, you agree to be bound by the following terms and conditions. If you do not agree, you must discontinue use immediately.

1. Age Restriction
   - This website is intended for individuals who are 18 years of age or older.
   - By using 27pub.com, you confirm that you meet this age requirement.

2. Ownership of Content
   - All content, including text, images, graphics, videos, and other materials on 27pub.com, is owned exclusively by the website owner.
   - Unauthorized reproduction, distribution, or modification of any content is strictly prohibited.

3. Limited, Non-Exclusive Use
   - You are granted a limited, non-exclusive, non-transferable right to access and use the website for personal, non-commercial purposes.
   - This license does not grant you ownership of any content or intellectual property.

4. Termination of Use
   - The website owner reserves the right to suspend or terminate your access to 27pub.com at any time, without notice, for any reason, including violation of these Terms of Use.

5. Disclaimer
   - The website is provided “as is” without warranties of any kind, express or implied.
   - The owner is not liable for any damages arising from your use of the website.

6. Governing Law
   - These Terms of Use shall be governed by and construed in accordance with the laws of [Insert State/Country].
   - Any disputes shall be resolved in the courts of [Insert Jurisdiction].

By continuing to use 27pub.com, you acknowledge that you have read, understood, and agree to these Terms of Use.
</p>
    </div>
</div>
</template>

<script setup>

</script>

<style>

.feedbacklist {
    text-emphasis: none;
}
.version {
    width: 10%;
}

.updates {
    width: 80%;
}

</style>